import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import SearchBar from "../../components/SearchBar";
import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import CustomPagination from "../../components/CustomPagination";
import FilterMenu from "../../components/filterMenu";
import GroupList from "./groupTable";
import AddGroup from "../../Modals/addGroup";
import { isValidInput } from "../../utils/validations";
import { useLazyGetTagGroupsQuery } from "../../service/group&tags";
import { showError } from "../../constants/toasts";
import AddTagGroup from "../../Modals/addTagGroup";
import Loader from "../../constants/Loader";

interface GroupRow {
  id: string;
  name: string;
  tags: string[];
  createAt: string;
  updateAt: string | null;
  isActive: boolean;
}

const ManageGroups = () => {
  const navigate = useNavigate();
  const [getTagGroupsApi] = useLazyGetTagGroupsQuery();
  const [open, setOpen] = useState(false);
  const handleCloseModal = () => {
    setOpen(false);
  };
  const [loading, setLoading] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);
  const [groupData, setGroupData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [selectedGroup, setSelectedGroup] = useState<GroupRow | null>(null);
  const [selectedGroupId, setSelectedGroupId] = useState("");
  const [count, setCount] = useState(10);
  const [page, setPage] = useState(1);

  const getGroupApi = async () => {
    setLoading(true);
    try {
      const response = await getTagGroupsApi({
        page,
        search: debouncedSearchTerm.trim(),
      }).unwrap();
      setLoading(false);
      setHasFetched(true);
      if (response.status === 200) {
        setGroupData(response?.data?.items || []);
        setCount(response?.data?.totalCount);
      } else {
        setGroupData([]);
      }
    } catch (error: any) {
      setHasFetched(true);
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getGroupApi();
  }, [page, debouncedSearchTerm]);

  return (
    <>
      <MainContainer>
        <Loader isLoad={loading} />
        <div className="main_title d_flex">
          <h1>Manage Groups</h1>
          <div className="right_s">
            <SearchBar
              searchTerm={searchTerm}
              placeholder="Search...."
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              value={searchTerm}
              onCross={() => setSearchTerm("")}
              onChange={(val: any) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);
                }
              }}
            />
            <Button
              className="btn btn_primary"
              onClick={() => {
                setOpen(true);
                setSelectedGroupId("");
                setSelectedGroup(null);
              }}
            >
              + Add New Group
            </Button>
            <FilterMenu
              startDate={null}
              endDate={null}
              setStartDate={() => { }}
              setEndDate={() => { }}
            />
          </div>
        </div>

        <div className="cards table_cards v2">
          <GroupList
            data={groupData}
            setSelectedGroup={setSelectedGroup}
            selectedGroup={selectedGroup}
            selectedGroupId={selectedGroupId}
            setSelectedGroupId={setSelectedGroupId}
            getGroupApi={getGroupApi}
          />
        </div>
        {groupData?.length ? (
          <CustomPagination
            currentPage={page - 1}
            totalPages={Math.ceil(count / 10)}
            count={count}
            pageSize={10}
            onPageChange={(page) => setPage(page + 1)}
          />
        ) : null}
      </MainContainer>
      <AddTagGroup
        open={open}
        onClose={handleCloseModal}
        setOpen={setOpen}
        selectedGroupId={selectedGroupId}
        selectedGroup={selectedGroup}
        getGroupApi={getGroupApi}
      />
    </>
  );
};

export default ManageGroups;
